import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Icon from 'components/Icon';
import Style from './FirstTile.module.scss';

const SeriesPromo = ({ description = null, ctaData = [] }) => (
  <div className={Style.promoDescription}>
    {description}
    <div className={Style.promoCTAContainer}>
      {ctaData.map(({ icon, text, url, onClick: handleClick }) => (
        <Link className={Style.defaultLinkButton} key={text} to={url} onClick={handleClick}>
          {icon && <Icon color="white" icon={icon} />}
          {text}
        </Link>
      ))}
    </div>
  </div>
);

SeriesPromo.propTypes = {
  description: PropTypes.string.isRequired,
  ctaData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default SeriesPromo;
